// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const bn: CountryValidator<"CA"> = createValidator(
  "ca.bn",
  30,
);

export default bn;
export const compact = bn.compact;
export const format = bn.format;
export const validate = bn.validate;
export const generate = (): string =>
  bn.generate?.() ??
  (() => {
    throw new Error(
      "Validator ca.bn cannot generate values",
    );
  })();
